import React, { useEffect, useState } from 'react'
import { delete_user_by_id, get_users, reset_user_by_id} from '../../helper/Api';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { GET_USER_FAIL,GET_USER_START,GET_USER_SUCCESS,DELETE_USER_START,DELETE_USER_SUCCESS } from '../../RTK/Slices/UserSlice';
import {FaRegEdit,FaEye} from "react-icons/fa"
import {MdDelete} from "react-icons/md"
import {Link} from 'react-router-dom';
import './ManageUser.css';
import { toast } from 'react-toastify';
import CustomBreadcrumbs from '../Tools/Breadcumbs';
import Spinner from '../Tools/spinner';

const ManageUser = (filterData) => {
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(100);
    const {authData}=useSelector((state)=>state.authData);
    const dispatch=useDispatch();
    const user_type=authData.user.user_type;
    const [users,setUsers]=useState([]);
    const fetchUsers=async()=>{
      setLoading(true);
      dispatch(GET_USER_START());
      try {
        const users=await get_users({
          searchStr: filterData.searchStr,
          department_level: filterData.department_level,
          department_id: filterData.departmentId || '',
          district_id: filterData.districtId || '',
        });
        if(users.data.status){
          dispatch(GET_USER_SUCCESS(users.data.users))
          setUsers(users.data.users)
        }else{
          dispatch(GET_USER_FAIL(users.data.message))
        }
      } catch (error) {
        dispatch(GET_USER_FAIL('something went wrong'))
      } finally {
        setLoading(false);
      }
    }

    useEffect(() => {
        fetchUsers();
    }, [filterData.searchStr, filterData.department_level, filterData.departmentId, filterData.districtId])
    const customStyles = {
      headCells: {
          style: {
              fontWeight:"bold",
              fontSize:"14px"
          },
      },
    };


    const columns = [
      {
        name: 'Empl. Code',
        selector: (row) => row.code,
        sortable: true,
        width: '10%'
      },
      {
        name: 'Username',
        selector: (row) => row.user_name,
        sortable: true,
        wrap:true,
        width: '25%'
      },
      {
        name: 'Designation',
        selector: (row) => row.designation,
        sortable: true,
        wrap:true,
        width: '15%'
      },
      {
        name: 'Mobile No',
        selector: (row) => row.mobile,
        sortable: true,
        width: '10%'
      },
      {
        name: 'Email',
        selector: (row) => row.email,
        sortable: true,
        wrap:true,
        width: '20%'
      },
      {
        name: 'Actions',
        width: '15%',
        allowOverflow: true,
        omit: false,
        style: {
          overflow: 'visible',
          padding: '0 8px',
        },
        selector: (row) => {
          return (
            <Link to={`/view-user/${row.id}`} className="icon_btn_primary">View Roles</Link>
          );        
        },
        sortable: false,
        ignoreRowClick: true,
        button: true,
      },
      {
        name: '',
        width: '5%',
        allowOverflow: true,
        omit: user_type !== 'l3', // Only show this column for 'l3' users
        style: {
          overflow: 'visible',
        },
        selector: (row) => {
          return (
            <div className='user_action'>
              <span className='pr-4'><Link to={`/edit-user/${row.id}`} className='icon_btn_action'><FaRegEdit/></Link></span>
            </div>
          );        
        },
        sortable: true,
        ignoreRowClick: true,
        button: true,
      }
    ];
  
    const reset_user=async(user_id)=>{
      if(user_id){
        const result = window.confirm("Are you sure you want to reset the user");
        if(result){
          try {
            const {data}=await reset_user_by_id(user_id);
            toast.success(data.message,{
              position: toast.POSITION.TOP_CENTER
            });
          } catch (error) {
            toast.error("getting error while reset user.",{
              position: toast.POSITION.TOP_CENTER
            });
          }
        }
      }else{
        toast.error("user id required.",{
          position: toast.POSITION.TOP_CENTER
        });
      }
    }
  
    // const delete_user=async(user_id)=>{
    //   if(user_id){
    //     const result = window.confirm("Are you sure you want to delete the user");
    //     if(result){
    //       try {
    //         dispatch(DELETE_USER_START());
    //         let formData={
    //           "added_by":authData.user.id
    //         }
    //         const {data}=await delete_user_by_id(formData,user_id);
    //         if(data.status){
    //           dispatch(DELETE_USER_SUCCESS({"id":user_id}));
    //           toast.success(data.message,{
    //             position: toast.POSITION.TOP_CENTER
    //           });
    //         }else{
    //           toast.error(data.message,{
    //             position: toast.POSITION.TOP_CENTER
    //           });
    //         }
            
    //       } catch (error) {
    //         toast.error("getting error while delete user.",{
    //           position: toast.POSITION.TOP_CENTER
    //         });
    //       }
    //     }
    //   }else{
    //     toast.error("user id required.",{
    //       position: toast.POSITION.TOP_CENTER
    //     });
    //   }
    // }
    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1); // Reset to the first page when rows per page changes
    };

    

    return (
    <div>
      {loading && <Spinner />}
      <div className="row" style={{padding: "8px 10px"}}>
          <div className="col-md-6">
              <h4 style={{ color: "#28326f", margin: 0 }}>Users</h4>
              <CustomBreadcrumbs linksArray={[]} title={"Users"} />
          </div>
          <div className="col-md-6"></div>
      </div>
        <DataTable
            customStyles={customStyles}
            className="dataTables_wrapper"
            columns={columns}
            data={users}
            fixedHeader
            fixedHeaderScrollHeight="800px"
            pagination
            paginationPerPage={rowsPerPage}
            paginationRowsPerPageOptions={[100, 250, 500, 1000]}
            onChangeRowsPerPage={handleChangeRowsPerPage}
        />
    </div>
  )
}

export default ManageUser
